// 统计接口
import { axiosPost } from "@/utils/request";

/**
 * 获取首页库存总览
 * @returns
 */
export const selectInventoryOverview = () => {
  return axiosPost({
    url: "/Statistics/selectInventoryOverview",
  });
};

/**
 * 获取出入库记录总览
 * @param {*} timeName
 * @returns
 */
export const selectOutInProductOverview = (warehouseId, timeName) => {
  return axiosPost({
    url: "/Statistics/selectOutInProductOverview",
    data: {
      warehouseId,
      timeName,
    },
  });
};

/**
 * 获取产品库存
 * @param {*} warehouseId
 * @returns
 */
export const selectProductInventory = (data) => {
  return axiosPost({
    url: "/Statistics/selectProductInventory",
    data: data,
  });
};

/**
 * 获取产品类型的库存
 * @param {*} data
 * @returns
 */
export const selectProductTypeInventory = (data) => {
  return axiosPost({
    url: "/Statistics/selectProductTypeInventory",
    data: data,
  });
};

/**
 * 查询产品库存根据产品id 和仓库id
 * @param {*} warehouseId
 * @param {*} productIds
 * @returns
 */
export const selectInventoryNumByProductId = (warehouseId, productIds) => {
  return axiosPost({
    url: "/Statistics/selectInventoryNumByProductId",
    data: {
      warehouseId: warehouseId,
      productId: productIds,
    },
  });
};
